import { useState, useEffect } from 'react';

const WhatsAppButton = () => {
  const [cookieConsentGiven, setCookieConsentGiven] = useState(false);
  const [bottomPosition, setBottomPosition] = useState('bottom-20');

  useEffect(() => {
    const checkCookieConsent = () => {
      const consent = localStorage.getItem('cookieConsent');
      setCookieConsentGiven(!!consent);
      setBottomPosition(consent ? 'bottom-6' : 'bottom-20');
    };

    checkCookieConsent();

    const handleConsentChange = () => {
      checkCookieConsent();
    };

    window.addEventListener('cookieConsentChanged', handleConsentChange);
    return () => window.removeEventListener('cookieConsentChanged', handleConsentChange);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '34644221998';
    const message = 'Hola, me gustaría obtener más información sobre Altta Talent Studio.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className={`fixed right-6 z-40 w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer ${bottomPosition}`}
      style={{ transition: 'bottom 0.3s ease-in-out, transform 0.3s ease-in-out' }}
    >
      <div className="w-full h-full flex items-center justify-center">
        <i className="ri-whatsapp-fill text-white text-2xl"></i>
      </div>
    </button>
  );
};

export default WhatsAppButton;